import { AdaptShellProvider } from "@adapt/ui-kit";
import { AuthProvider } from "@adapt/auth";
import { BrowserRouter } from "react-router-dom";
import { Suspense } from "react";
import { AppRouter } from "./app/router";

const CONFIG_OPTIONS = { defaults: { apiBaseUrl: "/api/v1" } };

export function App(): React.JSX.Element {
  return (
    <Suspense fallback={null}>
    <AuthProvider>
      <AdaptShellProvider
        authenticate={false}
        defaultThemeMode="dark"
        configOptions={CONFIG_OPTIONS}
        themeStorageKey="adapt-theme"
      >
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
      </AdaptShellProvider>
    </AuthProvider>
    </Suspense>
  );
}
